export const SVG = {
  logo_main: require('../assets/images/svg/logo_main.svg').default,
  logo_sub: require('../assets/images/svg/logo_sub.svg').default,
  background_main: require('../assets/images/svg/background_main.svg').default,
  nav_manage_program: require('../assets/images/svg/nav_manage_program.svg').default,
  nav_manage_program_active: require('../assets/images/svg/nav_manage_program_active.svg').default,
  nav_manage_club_join: require('../assets/images/svg/nav_manage_club_join.svg').default,
  nav_manage_club_join_active: require('../assets/images/svg/nav_manage_club_join_active.svg').default,
  nav_search_info: require('../assets/images/svg/nav_search_info.svg').default,
  nav_search_info_active: require('../assets/images/svg/nav_search_info_active.svg').default,
  icon: {
    signout: require('src/assets/images/svg/signout.svg').default,
  },
  filter: require('src/assets/images/svg/filter.svg').default,
}